import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMakeLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10453_52188)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.69788 3.868L0.0595061 17.0757C-0.0061126 17.2068 -0.0170308 17.3585 0.02915 17.4976C0.0753309 17.6367 0.174834 17.7517 0.305798 17.8175L3.88326 19.6153C3.94813 19.648 4.0188 19.6676 4.09124 19.6729C4.16368 19.6783 4.23647 19.6693 4.30544 19.6465C4.37441 19.6237 4.43821 19.5876 4.49321 19.5402C4.54821 19.4927 4.59332 19.4349 4.62596 19.37L11.2634 6.16225C11.296 6.09732 11.3155 6.02659 11.3208 5.95411C11.3261 5.88163 11.3171 5.80882 11.2942 5.73984C11.2713 5.67086 11.2351 5.60707 11.1875 5.55211C11.14 5.49715 11.0821 5.4521 11.0171 5.41954L7.43963 3.62266C7.3748 3.58992 7.30413 3.57031 7.23169 3.56497C7.15925 3.55963 7.08647 3.56866 7.01754 3.59155C6.9486 3.61444 6.88487 3.65073 6.83001 3.69834C6.77516 3.74595 6.73025 3.80393 6.69788 3.86896V3.868Z",
				fill: "url(#paint0_linear_10453_52188)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.4436 3.67188H22.4485C22.7532 3.67188 23.0014 3.92104 23.0014 4.22483V19.0071C23.0014 19.1539 22.9432 19.2946 22.8395 19.3985C22.7358 19.5023 22.5952 19.5608 22.4485 19.561H18.4436C18.2968 19.5608 18.1562 19.5023 18.0525 19.3985C17.9489 19.2946 17.8906 19.1539 17.8906 19.0071V4.22579C17.8906 3.92104 18.1388 3.67188 18.4436 3.67188Z",
				fill: "url(#paint1_linear_10453_52188)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.2807 3.91471L9.43925 18.3118C9.41078 18.4554 9.44053 18.6044 9.52194 18.7261C9.60336 18.8477 9.72977 18.9321 9.87337 18.9605L13.7977 19.7521C14.0987 19.8125 14.3919 19.618 14.4504 19.317L17.2909 4.92097C17.3191 4.77739 17.2892 4.62849 17.2078 4.50688C17.1265 4.38527 17.0002 4.30087 16.8567 4.27217L12.9314 3.47963C12.86 3.46526 12.7865 3.46512 12.7151 3.47923C12.6437 3.49333 12.5758 3.5214 12.5152 3.56183C12.4547 3.60225 12.4027 3.65423 12.3623 3.71479C12.3219 3.77535 12.2948 3.84329 12.2807 3.91471Z",
				fill: "url(#paint2_linear_10453_52188)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10453_52188",
			x1: 1.43759,
			y1: 18.6877,
			x2: 11.5001,
			y2: 164307e-9,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FF00FF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .17,
					stopColor: "#E90CF9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#C023ED"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .73,
					stopColor: "#B02DE9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B02DE9"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_10453_52188",
			x1: 458278e-9,
			y1: 22.9995,
			x2: 23.0005,
			y2: -45879e-8,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#B02DE9" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .02,
					stopColor: "#B02DE9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .8,
					stopColor: "#6D00CC"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6D00CC"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_10453_52188",
			x1: -334979e-9,
			y1: 22.9999,
			x2: 22.9997,
			y2: -748805e-10,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FF00FF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .02,
					stopColor: "#FF00FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#E90CF9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .23,
					stopColor: "#C023ED"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .3,
					stopColor: "#B02DE9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .42,
					stopColor: "#A42BE3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#8626D5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .85,
					stopColor: "#6021C3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6021C3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10453_52188",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 23,
				height: 23,
				fill: "white"
			})
		})
	] })]
});
export default SvgMakeLogo;
